export default {
    router:
        [
            {
                "id": "1",
                "menuType": "1",
                "menuName": "基本设置",
                "menuIcon": "el-icon-s-tools",
                "menuPath": "",
                "menuRoute": "",
                "menuTemplate": "",
                "children": [
                    {
                        "id": "101",
                        "menuType": "2",
                        "menuName": "菜单管理",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/menu/index",
                        "menuRoute": "/menu/index",
                        "menuTemplate": "/pages/systemmenu/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },

                        ]
                    },
                    {
                        "id": "102",
                        "menuType": "2",
                        "menuName": "机构管理",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/organization/index",
                        "menuRoute": "/organization/index",
                        "menuTemplate": "/pages/systemorganization/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },

                        ]
                    },
                    {
                        "id": "103",
                        "menuType": "2",
                        "menuName": "角色管理",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/role/index",
                        "menuRoute": "/role/index",
                        "menuTemplate": "/pages/systemrole/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },

                        ]
                    },
                    {
                        "id": "104",
                        "menuType": "2",
                        "menuName": "用户管理",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/user/index",
                        "menuRoute": "/user/index",
                        "menuTemplate": "/pages/systemuser/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "04",
                                "menuType": "3",
                                "menuName": "重置",
                                "menuIcon": "el-icon-refresh",
                                "menuPath": "",
                                "menuRoute": "handleReset",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                    {
                        "id": "105",
                        "menuType": "2",
                        "menuName": "密码修改",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/modify/user",
                        "menuRoute": "/modify/user",
                        "menuTemplate": "/pages/systemmodify/index.vue",
                        "children": []
                    },
                ]
            },
            {
                "id": "8",
                "menuType": "1",
                "menuName": "试题管理",
                "menuIcon": "el-icon-document",
                "menuPath": "",
                "menuRoute": "",
                "menuTemplate": "",
                "children": [
                    {
                        "id": "803",
                        "menuType": "2",
                        "menuName": "试题分类",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/question/category",
                        "menuRoute": "/question/category",
                        "menuTemplate": "/pages/questioncategory/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                    {
                        "id": "804",
                        "menuType": "2",
                        "menuName": "试题信息",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/question/detail",
                        "menuRoute": "/question/detail",
                        "menuTemplate": "/pages/questiondetail/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "04",
                                "menuType": "3",
                                "menuName": "批量导入",
                                "menuIcon": "el-icon-bottom-left",
                                "menuPath": "",
                                "menuRoute": "handleImport",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                ]
            },
            {
                "id": "9",
                "menuType": "1",
                "menuName": "问卷管理",
                "menuIcon": "el-icon-printer",
                "menuPath": "",
                "menuRoute": "",
                "menuTemplate": "",
                "children": [
                    {
                        "id": "801",
                        "menuType": "2",
                        "menuName": "问卷分类",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/paper/category",
                        "menuRoute": "/paper/category",
                        "menuTemplate": "/pages/papercategory/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                    {
                        "id": "802",
                        "menuType": "2",
                        "menuName": "问卷信息",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/paper/detail",
                        "menuRoute": "/paper/detail",
                        "menuTemplate": "/pages/paperdetail/index.vue",
                        "children": [
                            {
                                "id": "01",
                                "menuType": "3",
                                "menuName": "新增",
                                "menuIcon": "el-icon-share",
                                "menuPath": "",
                                "menuRoute": "handleInsert",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "修改",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                    {
                        "id": "803",
                        "menuType": "2",
                        "menuName": "问卷组题",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/paper/question",
                        "menuRoute": "/paper/question",
                        "menuTemplate": "/pages/paperquestion/index.vue",
                        "children": [
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "问卷组题",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleUpdate",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "03",
                                "menuType": "3",
                                "menuName": "问卷链接",
                                "menuIcon": "el-icon-position",
                                "menuPath": "",
                                "menuRoute": "handleDetail",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                ]
            },
            {
                "id": "10",
                "menuType": "1",
                "menuName": "调查管理",
                "menuIcon": "el-icon-mobile",
                "menuPath": "",
                "menuRoute": "",
                "menuTemplate": "",
                "children": [
                    {
                        "id": "1001",
                        "menuType": "2",
                        "menuName": "调查管理",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/answer/detail",
                        "menuRoute": "/answer/detail",
                        "menuTemplate": "/pages/answerdetail/index.vue",
                        "children": [
                            {
                                "id": "02",
                                "menuType": "3",
                                "menuName": "导出记录",
                                "menuIcon": "el-icon-bottom-right",
                                "menuPath": "",
                                "menuRoute": "handleExamExport",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "03",
                                "menuType": "3",
                                "menuName": "导入记录",
                                "menuIcon": "el-icon-bottom-left",
                                "menuPath": "",
                                "menuRoute": "handleExamImport",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "04",
                                "menuType": "3",
                                "menuName": "数据统计",
                                "menuIcon": "el-icon-edit",
                                "menuPath": "",
                                "menuRoute": "handleExamReport",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },
                ]
            },
            {
                "id": "20",
                "menuType": "1",
                "menuName": "系统配置",
                "menuIcon": "el-icon-s-operation",
                "menuPath": "",
                "menuRoute": "",
                "menuTemplate": "",
                "children": [
                    {
                        "id": "2001",
                        "menuType": "2",
                        "menuName": "系统参数",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/config/detail",
                        "menuRoute": "/config/detail",
                        "menuTemplate": "/pages/systemconfig/index.vue",
                        "children": []
                    },
                    {
                        "id": "2002",
                        "menuType": "2",
                        "menuName": "系统信箱",
                        "menuIcon": "el-icon-caret-right",
                        "menuPath": "/letter/index",
                        "menuRoute": "/letter/index",
                        "menuTemplate": "/pages/systemletter/index.vue",
                        "children": [
                            {
                                "id": "03",
                                "menuType": "3",
                                "menuName": "查看",
                                "menuIcon": "el-icon-view",
                                "menuPath": "",
                                "menuRoute": "handleDetail",
                                "menuTemplate": "",
                                "children": []
                            },
                            {
                                "id": "08",
                                "menuType": "3",
                                "menuName": "删除",
                                "menuIcon": "el-icon-delete",
                                "menuPath": "",
                                "menuRoute": "handleDelete",
                                "menuTemplate": "",
                                "children": []
                            },
                        ]
                    },

                ]
            },
        ]
}